import {AudioTrack, VideoTrack} from './types';
import {LocalAudioTrackPublication, LocalDataTrack, LocalDataTrackPublication, LocalTrackPublication, LocalVideoTrackPublication, Track} from 'twilio-video';
import {AccessType, LogLevel, LogResource} from '@app/modules/shared/data/constants';
import {LogService} from '@app/services/log.service';
import {LocalUserAction} from '@app/state/local-user.state';
import {Store} from '@ngxs/store';

export class CurrentUserTracks {
  public audio: AudioTrack<LocalAudioTrackPublication>;
  public video: VideoTrack<LocalVideoTrackPublication>;
  private userId: number;
  private role: AccessType;
  private data: LocalDataTrack;
  private mediaWrapper: HTMLElement;

  constructor() {
    this.audio = new AudioTrack();
    this.video = new VideoTrack();
    this.data = null;
  }

  public setId(userId: number) {
    this.userId = userId;
  }

  public setRole(role: AccessType) {
    this.role = role;
  }

  public setMediaWrapper(mediaWrapper: HTMLElement) {
    this.mediaWrapper = mediaWrapper;
  }

  public setAudioTrack(trackPublication: Map<Track.SID, LocalTrackPublication> | null) {
    LogService.writeLog(`Set current user audio track`, LogLevel.DEBUG, LogResource.WRTC);
    if (trackPublication && trackPublication.size > 0) {
      if (this.role === AccessType.SUPPORT) {
        // this.audio.isMuted = true;
      }
      this.audio.isProvided = true;

      this.audio.trackPublication = trackPublication.values().next().value;

      if (this.audio.isMuted) {
        this.toggleDisableAudio(this.audio.isMuted);
      } else {
        this.audio.isMuted = !this.audio.trackPublication.track.isEnabled;
      }

    } else {
      this.audio.isProvided = false;
      this.audio.isMuted = false;
      this.audio.trackPublication = null;
    }
  }

  public setVideoTrack(trackPublication: Map<Track.SID, LocalTrackPublication> | null) {
    LogService.writeLog(`Set current user video track`, LogLevel.DEBUG, LogResource.WRTC);
    if (trackPublication && trackPublication.size > 0) {
      this.video.isProvided = true;
      this.video.trackPublication = trackPublication.values().next().value;
      this.attachVideoTrack();
      if (this.role === AccessType.TEACHER) {
        this.video.trackPublication.setPriority('high');
      }
    } else {
      this.video.isProvided = false;
      this.video.isMuted = false;
      this.video.trackPublication = null;
    }
  }

  public setDataTrack(trackPublication: Map<Track.SID, LocalDataTrackPublication>) {
    // this.data = trackPublication.values().next().value;
  }

  public setDataTrackA(trackPublication: any) {
    this.data = trackPublication;
  }

  public sendPointerInfo(object) {
    this.data.send(JSON.stringify(object));
  }

  public toggleDisableAudio(isMuted) {
    LogService.writeLog(`Try to  ${isMuted ? 'mute' : 'unmute'} current user audio track`, LogLevel.DEBUG, LogResource.WRTC);
    if (this.audio.isProvided && this.audio.trackPublication.track) {
      if (isMuted) {
        LogService.writeLog('Disabled local audio track', LogLevel.DEBUG, LogResource.WRTC);
        this.audio.trackPublication.track.disable();
      } else {
        LogService.writeLog('Enable local audio track', LogLevel.DEBUG, LogResource.WRTC);
        this.audio.trackPublication.track.enable();
      }
    }
    this.audio.isMuted = isMuted;
  }

  public toggleDisableVideo(isMuted) {
    LogService.writeLog(`Try to  ${isMuted ? 'mute' : 'unmute'} current user video track`, LogLevel.DEBUG, LogResource.WRTC);
    if (this.video.isProvided) {
      if (isMuted) {
        LogService.writeLog('Disabled local video track', LogLevel.DEBUG, LogResource.WRTC);
        this.video.trackPublication.track.disable();
      } else {
        LogService.writeLog('Enable local video track', LogLevel.DEBUG, LogResource.WRTC);
        this.video.trackPublication.track.enable();
      }
      this.video.isMuted = isMuted;
    } else {
      // TODO - check if this is not needed remove
      this.video.isMuted = isMuted;
    }
  }

  public detachVideoTrackAndRemoveWrapper() {
    LogService.writeLog('Try to detach local video Track', LogLevel.DEBUG, LogResource.WRTC);
    if (this.video.isProvided) {
      this.video.trackPublication.track.detach();
      this.mediaWrapper.innerHTML = '';
    }
  }

  public attachVideoTrack() {
    LogService.writeLog('Try to attach local video Track', LogLevel.DEBUG, LogResource.WRTC);
    if (this.video.isProvided) {
      const videoElement = this.video.trackPublication.track.attach();
      videoElement.style.transform = 'scale(-1, 1)';
      this.mediaWrapper.prepend(videoElement);
      LogService.writeLog('Local video track is attached', LogLevel.DEBUG, LogResource.WRTC);
    }

  }

  public stopAudioTrack() {
    if (this.audio.isProvided) {
      LogService.writeLog(`Stop current user audio track`, LogLevel.DEBUG, LogResource.WRTC);

      this.audio.trackPublication.track.stop();
    }
  }

  public stopVideoTrack() {
    if (this.video.isProvided) {
      LogService.writeLog(`Stop current user video track`, LogLevel.DEBUG, LogResource.WRTC);
      this.video.trackPublication.track.stop();
    }
  }

  public disconnect() {
    this.stopAudioTrack();
    this.detachVideoTrackAndRemoveWrapper();
    this.stopVideoTrack();
  }
}
